import React from 'react';
import { cx } from '@linaria/atomic';
import type { PolymorphicComponentPropWithRef } from '../../../type-utils/polymorphic';
import { trayBody } from './tray.styles';

type ComponentProps = {
  children: React.ReactNode;
  className?: string;
};

type TrayBodyProps<T extends React.ElementType> = PolymorphicComponentPropWithRef<T, ComponentProps>;

export const TrayBody = React.forwardRef(
  <T extends React.ElementType = 'section'>(
    { as, children, className, ...rest }: TrayBodyProps<T>,
    ref: React.Ref<HTMLElement>
  ) => {
    const Component = as || 'section';
    return (
      <Component ref={ref} className={cx(trayBody, 'tray-body', className)} {...rest}>
        {children}
      </Component>
    );
  }
);

TrayBody.displayName = 'TrayBody';
